/**
 * Lineups tab: single pitch (home top half, away bottom half) + benches.
 */

import React, { useMemo } from 'react';
import { Text, View } from 'react-native';
import { useTheme } from '../../../src/theme/useTheme';
import { useThemeContext } from '../../../src/theme/ThemeContext';
import type { MatchHubMockData } from '../../../src/match/types/matchHub.types';
import { MatchHubLineupsPitch } from './MatchHubLineupsPitch';
import { getMatchHubLineupsStyles } from './MatchHubLineupsPanel.styles';

export interface MatchHubLineupsPanelProps {
  data: MatchHubMockData;
}

export const MatchHubLineupsPanel: React.FC<MatchHubLineupsPanelProps> = ({ data }) => {
  const theme = useTheme();
  const { isDark } = useThemeContext();
  const styles = useMemo(() => getMatchHubLineupsStyles(theme, isDark), [theme, isDark]);
  const { lineups } = data;
  const hasLineupData =
    lineups.home.starting.length > 0 ||
    lineups.away.starting.length > 0 ||
    lineups.home.bench.length > 0 ||
    lineups.away.bench.length > 0;

  return (
    <View testID="match-hub-lineups" style={styles.root}>
      {lineups.isExpected && data.phase === 'pre' && hasLineupData && (
        <View style={styles.banner}>
          <Text style={styles.bannerText}>
            Expected lineups — confirmed XIs usually appear about 1 hour before kickoff.
          </Text>
        </View>
      )}
      {hasLineupData ? (
        <MatchHubLineupsPitch data={data} styles={styles} />
      ) : (
        <View style={styles.emptyStateCard}>
          <Text style={styles.emptyStateTitle}>Lineups are not available yet</Text>
          <Text style={styles.emptyStateText}>
            Check back closer to kickoff for confirmed starting elevens and bench players.
          </Text>
        </View>
      )}
    </View>
  );
};
